/**
 * Web-specific initialization for Parse SDK
 * This ensures proper setup for web environments, especially Safari
 */

// eslint-disable-next-line @typescript-eslint/no-var-requires, @typescript-eslint/no-require-imports
const Parse = require('parse');

// Environment variable access that works in both development and production
const getEnvVar = (name: string): string => {
  // Try multiple ways to access environment variables
  if (typeof process !== 'undefined' && process.env && process.env[name]) {
    return process.env[name];
  }
  
  // For webpack DefinePlugin variables
  if (typeof window !== 'undefined' && (window as any).__ENV__ && (window as any).__ENV__[name]) {
    return (window as any).__ENV__[name];
  }
  
  // Try accessing via require('@env') if available
  try {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    const env = require('@env');
    if (env && env[name]) {
      return env[name];
    }
  } catch (e) {
    // Silent fail - module not available
  }
  
  return '';
};

export const initializeParseForWeb = (): boolean => {
  if (typeof window === 'undefined') {
    // Not a web environment
    return false;
  }

  try {
    const PARSE_APP_ID = getEnvVar('PARSE_APP_ID');
    const PARSE_JS_KEY = getEnvVar('PARSE_JS_KEY');
    const PARSE_SERVER_URL = getEnvVar('PARSE_SERVER_URL');

    if (!PARSE_APP_ID || !PARSE_JS_KEY || !PARSE_SERVER_URL) {
      console.error('Missing required Parse environment variables for web initialization');
      return false;
    }

    // Check if already initialized
    if (Parse.applicationId && Parse.applicationId === PARSE_APP_ID) {
      return true;
    }

    // Initialize Parse for web
    Parse.initialize(PARSE_APP_ID, PARSE_JS_KEY);
    Parse.serverURL = PARSE_SERVER_URL;

    // Safari-specific configurations
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) {
      // Safari may need additional configuration
      Parse.LiveQuery.on('error', (error: any) => {
        console.warn('Parse LiveQuery error (Safari):', error);
      });
    }

    console.log('Parse initialized successfully for web environment');
    return true;
  } catch (error) {
    console.error('Failed to initialize Parse for web:', error);
    return false;
  }
};

// Auto-initialize when this module is imported
if (typeof window !== 'undefined') {
  // Use setTimeout to ensure DOM is ready
  setTimeout(() => {
    initializeParseForWeb();
  }, 0);
}

export default initializeParseForWeb; 